
<div class="fdm-floatbar">

  <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">

    <li class="fdm-linked fdm-options-button pointer" (click)="cancel();layers.selectedGuide = null;">
      <fa-icon icon="times"></fa-icon>
    </li>
    <li class="fdm-linked fdm-options-button pointer" (click)="snapCamera()">
      <fa-icon icon="camera-retro"></fa-icon>
    </li>
    <li class="fdm-linked fdm-options-button pointer" (click)="flyTo()" [matTooltip]="'MAP.FLY_TO' | translate">
      <fa-icon icon="paper-plane"></fa-icon>
    </li>

    <h2>{{ 'GENERIC.GUIDE' | translate }}</h2>
    &nbsp; <fa-icon class="fdm-linked pointer" style="color:red;" icon="times-circle" (click)="delete()"></fa-icon>
  </div>

  <div  class="fdm-sidebar-body fdm-sidebar-content text-center" *ngIf="loading">
    <mat-spinner style="margin:2rem auto;" strokeWidth="3"></mat-spinner>
  </div>

  <div class="fdm-sidebar-body fdm-sidebar-content" *ngIf="!loading && !guide">
    [{{ id }}]
    {{ 'MAP.GUIDE_MISSING' | translate }}</div>

  <div class="fdm-sidebar-body fdm-sidebar-content" *ngIf="!loading && guide">
    <div class="fdm-choice-box">
      <label>{{ 'MAP.NAME' | translate }} </label>
      <div>
        <input matInput [(ngModel)]="guide.label">
      </div>
    </div>

    <div class="fdm-choice-box">
      <label>{{ 'MAP.DESC' | translate }}</label>
      <div>
        <textarea matInput [(ngModel)]="guide.desc"></textarea>
      </div>
    </div>

    <div class="mt-2 text-right">
      <button mat-flat-button color="primary"(click)="save();" class="float-right fdm-button"><fa-icon icon="times"></fa-icon> {{ 'GENERIC.CLOSE' | translate }}</button>
      
    </div>

  </div>

</div>